<template>
<div>
  <div class="section-header">
    <h1 class="hide-at-xs">{{cohort.name}}</h1>
    <div class="row">
      <router-link :to="'/cohorts/' + $route.params.id" style="margin-right: 10px">Info</router-link>
      <button @click="deleteModal=true">Delete</button>
    </div>
  </div>
  <div class="card card--white">
    <div class="card card--container">
      <h-input v-model="cohort.name" label="Cohort Name" />
      <clients
        header="Clients"
        :clients="clients"
        @addClients="addClientsToCohort"
        @revoke="deleteClientCohort"></clients>
    </div>
  </div>
  <modal v-if="deleteModal">
    <div class="card--container" style="background-color: #70BFF6">
      <h3 style="color: white">Are you sure you want to delete this cohort?</h3>
      <div class="row small-top">
        <button class="btn btn--outline" @click="destroy">Yes I am sure</button>
        <button class="btn btn--outline" @click="deleteModal=false">No</button>
      </div>
    </div>
  </modal>
</div>
</template>

<script>
import dataStore from "@/services/api/store";
import snackbarHub from "@/services/hubs/snackbar";
import clients from "@/pages/coaches/components/clients/list";
import axios from "axios";
import modal from "@/components/modal";

const STORE_COHORT = "CoachCohort";
const STORE_CLIENTS = "CoachClients";
const STORE_CLIENT_COHORT = "CoachClientCohorts";
const REMOVE_CLIENT_COHORT_URL = `${
  process.env.VUE_APP_API_URL
}coaches/client-cohorts/remove/`;

export default {
  data() {
    return {
      cohort: {},
      clients: [],
      errors: [],
      deleteModal: false
    };
  },
  components: {
    clients,
    modal
  },
  created() {
    dataStore.find(STORE_COHORT, this.$route.params.id).then(r => {
      this.cohort = r;
    });
    dataStore
      .findAll(
        STORE_CLIENTS,
        { clientcohorts__cohort: this.$route.params.id },
        { force: true }
      )
      .then(r => {
        this.clients = r;
      });
  },
  methods: {
    destroy() {
      dataStore.destroy(STORE_COHORT, this.$route.params.id).then(() => {
        snackbarHub.update("Deleted");
        this.$router.push("/cohorts");
        this.deleteModal = false;
      });
    },
    // TODO: MAKE ENDPOINT THAT TAKES COHORT AND CLIENT ID AND REMOVES FROM COHORT
    deleteClientCohort(client) {
      axios
        .post(REMOVE_CLIENT_COHORT_URL, {
          client: client.id,
          cohort: this.$route.params.id
        })
        .then(() => {
          this.clients = this.clients.filter(c => c.id !== client.id);
          snackbarHub.update("Revoked");
        });
    },
    addClientsToCohort(clients) {
      this.errors = [];
      Promise.all(
        clients.map(client => {
          return dataStore
            .create(STORE_CLIENT_COHORT, {
              client: client.id,
              cohort: this.$route.params.id
            })
            .catch(() => {
              this.errors = [
                `Unable to add ${client.first_name} ${
                  client.last_name
                } because they're already part of this cohort`,
                ...this.errors
              ];
            });
        })
      ).then(() => {
        dataStore
          .findAll(
            STORE_CLIENTS,
            { clientcohorts__cohort: this.$route.params.id },
            { force: true }
          )
          .then(r => {
            this.clients = r;
            snackbarHub.update("Saved");
          });
      });
    }
  }
};
</script>

<style>
</style>
